export const sites = [
    'dev',
    'staging',
    'booking-staging',
    'booking-dev',
    'local'
];

export default {
    computed: {
        development() {
            const segments = window.location.host.split('.');
            const isDev = segments.some(r => sites.indexOf(r) >= 0);

            this.setIsDevLocation(isDev);
            return isDev;
        },
    },
    methods: {
        setLocationIfCharges() {
            let location = 'GB';

            if (this.vehicles[0].charges && this.vehicles[0].charges.data.length) {
                location = 'US';
            }

            this.setMockLocation(location);
        },
        setIsDevLocation(value) {
            this.$store.dispatch('setDevLocation', value)
                .catch(error => {
                    this.$store.dispatch('createFatalError');
                });
        },
        setMockLocation(value) {
            this.$store.dispatch('setMockLocation', value)
                .catch(error => {
                    this.$store.dispatch('createFatalError');
                });
        },
        setMockDevice(device) {
            this.$store.dispatch('setScreenType', device)
                .catch(error => {
                    this.$store.dispatch('createFatalError');
                });
        },
        getUserLocation() {
            this.$store.dispatch('fetchUserLocation')
                .catch(error => {
                    this.$store.dispatch('createFatalError');
                });

        },
    },
}